import type { PrimeNGConfigType } from 'primeng/config';

/**
 * PrimeNG hard-codes 1rem on a few inner inputs that a control's size="small"
 * never reaches. This global pass-through adds PrimeNG's own -sm class to them,
 * so they render at the 14px body size without custom CSS; the gaps no -sm
 * class reaches are listed in type-scale.ts.
 */
export const SMALL_SIZE_PT = Object.freeze({
  multiSelect: { pcFilter: { root: { class: 'p-inputtext-sm' } } },
  paginator: { pcRowPerPageDropdown: { root: { class: 'p-select-sm' } } },
  orderList: { pcListbox: { pcFilter: { root: { class: 'p-inputtext-sm' } } } },
} satisfies NonNullable<PrimeNGConfigType['pt']>);
